module.exports = __webpack_public_path__ + "static/media/pexels-photo-159888.056b3a25.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/app2soft/images/006_da/pexels-photo-159888.jpeg
// module id = 776
// module chunks = 0